import {
  defaultQuery,
  fetchPracticesQueryDocument,
  peopleQueryDocument,
  policiesQueryDocument,
} from "./constants";

function getLabels(id: any) {
  if (id === "1") {
    return "Policies";
  } else if (id === "2") {
    return "Practices";
  } else if (id === "3") {
    return "People";
  } else {
    return "";
  }
}



function getQuery(id: any) {
  if (id === "1") {
    return policiesQueryDocument;
  } else if (id === "2") {
    return fetchPracticesQueryDocument;
  } else if (id === "3") {
    return peopleQueryDocument;
  } else {
    return defaultQuery;
  }
}

export { getLabels, getQuery };
